import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { classNames } from "@util/html.util";

// components
import { LogoHorizontal } from "@components/logo";
import { AsanaLogo } from "@ui/asana-logo";
import { Add } from "@material-ui/icons";

// styles
import { colors } from "@styles/color.styles";

export interface AclackaProps {
  className?: string;
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    maxWidth: 480,
  },
  cwLogo: {
    width: "50%",
  },
  asanaLogo: { width: "37%", marginTop: 3 },
  plus: { padding: "0px 5px 0px 9px", fontSize: 38, fill: colors.blueDusk.standard },
});

export const Aclacka = ({ className }: AclackaProps) => {
  const classes = useStyles();

  return (
    <div className={classNames([classes.container, className])}>
      <LogoHorizontal fill={colors.blueDusk.standard} className={classes.cwLogo} />
      <Add className={classes.plus} />
      <AsanaLogo className={classes.asanaLogo} />
    </div>
  );
};
